import { Reveal, Chapter } from "@/components/portfolio/motion";

const ENTRIES = [
  {
    role: "CMO & COO",
    sub: "Senior Marketing Lead / Head of Marketing, US",
    company: "Tentworks Interactive",
    period: "July 2019 – Present",
    location: "San Francisco, CA",
    groups: [
      {
        head: "City Block Builder launch",
        body: "Owned end-to-end go-to-market for City Block Builder on PC. Drove 14,730 wishlists and 9,243 paid purchases, contributing directly to launch month revenue. The teaser trailer reached about 210K views.",
      },
      {
        head: "Becoming Pablo, pre-launch",
        body: "Currently leading pre-launch GTM for Becoming Pablo. Over 9,400 wishlists so far, tracking toward a 20,000 plus pre-launch goal. Pitched gaming press, managed review and press keys, and built visibility through festival participation.",
      },
      {
        head: "Community, from zero",
        body: "Built and ran Tentworks' Discord from 0 to 2,400 plus members, acting as the primary point of contact for players and turning daily feedback into real product and marketing decisions. Designed an AI-driven engagement campaign that lifted daily active users by about 22 percent. Grew Instagram organically from 126 to 1,882 followers, a nearly 1,400 percent increase.",
      },
      {
        head: "On the ground",
        body: "Represented Tentworks at seven industry trade shows, including Gamescom three times, owning budget, vendor negotiation, booth design, and on-site demo logistics. Secured publisher meetings and drove wishlist spikes at every show. Led a team of three as a player-coach, hands-on with AI tools across campaigns, decks, the website, and content.",
      },
    ],
  },
  {
    role: "Freelance Marketing Consultant & AI Product Builder",
    sub: "Alongside full-time work at Tentworks",
    company: "Self-Employed",
    period: "2025 – Present",
    location: "San Francisco, CA",
    body: "I help fast-growing startups and small businesses with marketing strategy and AI-assisted, full-stack product development. This is where the builder side of this site comes from, see the Projects section below for what I've actually shipped.",
  },
  {
    role: "CSM / Project Analyst",
    company: "Smart Energy Water",
    period: "2016 – 2019",
    location: "Irvine, CA",
    body: "Primary liaison between B2B enterprise clients and technical teams, building partnerships that increased platform adoption and secured renewals. Led data-driven sales enablement and partner support for the Business Development team. Used product analytics to assess account performance and user behavior, applying insights to optimize channel investments and enhance client satisfaction. Oversaw QA and feature validation through UAT on web, iOS, and Android platforms.",
  },
];

const Entry = ({ e, i }) => (
  <Reveal delay={i * 0.05}>
    <article
      data-testid={`experience-card-${i}`}
      className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 border-t border-line first:border-t-0"
    >
      <div className="md:col-span-4">
        <p className="font-mono text-xs uppercase tracking-[0.18em] text-accent">
          {e.period}
        </p>
        <p className="mt-2 text-sm text-muted">{e.location}</p>
        {e.sub && (
          <p className="mt-3 text-sm text-ink-soft md:max-w-[16rem]">{e.sub}</p>
        )}
      </div>

      <div className="md:col-span-8">
        <h3 className="font-display text-xl sm:text-2xl font-bold text-ink">
          {e.role}
        </h3>
        <p className="mt-1 text-base font-medium text-accent">{e.company}</p>

        {e.groups && (
          <div className="mt-6 space-y-5">
            {e.groups.map((g, gi) => (
              <div key={gi} data-testid={`experience-${i}-group-${gi}`}>
                <p className="font-semibold text-ink">{g.head}</p>
                <p className="mt-1 text-ink-soft leading-relaxed">{g.body}</p>
              </div>
            ))}
          </div>
        )}

        {e.body && (
          <p className="mt-5 text-ink-soft leading-relaxed max-w-2xl">{e.body}</p>
        )}
      </div>
    </article>
  </Reveal>
);

export const Experience = () => (
  <section
    id="work"
    data-testid="experience-section"
    className="scroll-mt-20 max-w-6xl mx-auto px-5 sm:px-8 py-20 sm:py-28 border-t border-line"
  >
    <Chapter num="02 / Experience" label="Experience" testId="experience-chapter" />
    <div>
      {ENTRIES.map((e, i) => (
        <Entry key={i} e={e} i={i} />
      ))}
    </div>
  </section>
);
